import Wrapper from '../assets/wrappers/Contact'
import React from 'react'
import Accordion from '../components/Accordion'
import { hofData } from '../utils'
// import img from '../assets/images/piano2.jpg'

export const HallOfFame = () => {
  return (
    // <section className='contact-section'>
    <Wrapper>
      {/*! <div className='main section-center initial-section'> */}
      <div className='main section-center hof'>
        {/* HALL OF FAME START */}
        {/*! <section id='overview' className='overview fame-section lavender'> */}
        {/*! <section id='overview' className='overview lavender'> */}
        {/* fame-section */}
        <section id='overview' className='overview '>
          <div className='section-center'>
            <div className='hof-title'>
              <h2
                style={{
                  marginBottom: '0em',
                }}
                className='section-title special-font'
              >
                our
              </h2>
              <h1 className='section-title' style={{ marginBottom: '0em' }}>
                hall of fame
              </h1>
              {/* <h2 className='section-title special-font'>2024</h2> */}
            </div>
            <div className='text-center flex-container famer-container'>
              <section className='questions magnolia'>
                {/* <div className='questions-container'> */}
                <div>
                  <div>
                    {/* <h1 className='section-title'>FAQs</h1> */}
                    <div className='accordion-container'>
                      {hofData.map((data, index) => (
                        // console.log(data)
                        // const { title, content } = data

                        <Accordion
                          key={index}
                          title={data.year}
                          content={data.content}
                        />
                      ))}
                    </div>
                  </div>
                </div>
              </section>
              {/*  */}
            </div>
          </div>
        </section>
        {/* HALL OF FAME END */}
      </div>
    </Wrapper>
  )
}
